import React from "react";

import { Dialog, DialogTitle, DialogContentText, DialogContent, DialogActions, Button } from "@mui/material";

const ConfirmModal = ({
	open,
	message,
	title,
	onClose,
	onConfirm,
	confirmText,
	cancelText,
	loading
}: {
	open: boolean;
	message: string;
	title: string;
	onClose: () => void;
	onConfirm: () => void;
	confirmText: string;
	cancelText: string;
	loading: boolean;
}) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">{title}</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">{message}</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>{cancelText}</Button>
				<Button onClick={onConfirm} autoFocus loading={loading} disabled={loading}>
					{confirmText}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmModal;
